import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { RMDClientFavouriteCarriersModel } from 'src/Models/RMDClientFavouriteCarriersModel';
import { RMDProviderFilterModel } from 'src/Models/RMDProviderFilterModel';

@Injectable({
  providedIn: 'root'
})
export class FrontRmdupdatesService {
  AppUrl: string = "";

  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.AppUrl = sessionStorage.getItem("BaseURL") || '';
    }
  }

  GetRMDClientFavouriteCarriers(TokenKey: string, clientId: number): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/RMDUpdates/GetRMDClientFavouriteCarriers/' + clientId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
  }

  RMDClientCarrierFavouriteAddRemove(TokenKey: string, favouriteCarriersModel: RMDClientFavouriteCarriersModel): Observable<any> {
    this.setAPIUrl();
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(this.AppUrl + 'api/RMDUpdates/RMDClientCarrierFavouriteAddRemove', favouriteCarriersModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetRMDUpdatesFindByCarrierID(TokenKey: string, carrierID: number): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/RMDUpdates/GetRMDUpdatesFindByCarrierID/' + carrierID;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
  }

  GetFrontCarrierFilter(TokenKey: string, filterModel: RMDProviderFilterModel): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/RMDUpdates/GetFrontCarrierFilter';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(fullAPIPath, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetFrontCarrierForPDF(TokenKey: string, filterModel: RMDProviderFilterModel): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/RMDUpdates/GetFrontCarrierForPDF';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(fullAPIPath, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }


  GetRMDUpdatesUnread(TokenKey: string, filterModel: RMDProviderFilterModel): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/RMDUpdates/GetRMDUpdatesFilterUnread/';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(fullAPIPath, filterModel, httpOptions).pipe(catchError(this.handleError));
  }

  GetRMDUpdatesUnreadCount(TokenKey: string, clientId: number): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/RMDUpdates/GetRMDUpdatesFilterUnreadCount/' + clientId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
  }

  addNotification(TokenKey: string, filterModel: RMDProviderFilterModel): Observable<any> {
    this.setAPIUrl();
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(this.AppUrl + 'api/RMDUpdates/AddNotification', filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return observableThrowError(error.status)
  }
}
